import { __makeTemplateObject } from "tslib";
import styled from "../../redoc-lib/src/styled-components";
export var ServerItem = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 10px 0;\n"], ["\n  padding: 10px 0;\n"])));
var templateObject_1;